<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="thesaurus && !isMobile" class="grid-wrap">
    <div class="grid-options">
      <div>
        <div
          v-for="sau in thesaurus.theme"
          :key="sau.label"
          class="checkbox-pill"
          :class="sau.label === selectedTheme && 'selected-op'"
        >
          <CheckboxSub
            :obj-data="sau"
            tipus="theme"
            :internal-checks="internalChecks"
            :open-option="sau.label === selectedTheme"
            @op-selected="thesaurusOpSelected"
            @change-internal-checks="changeInternalChecks"
          />
        </div>
      </div>
    </div>
    <div class="grid-options">
      <div v-if="selectedTheme">
        <div
          v-for="sau in currentSubthemes.subThemes"
          :key="sau.label"
          class="checkbox-pill"
          :class="sau.label === selectedSubtheme && 'selected-op'"
        >
          <CheckboxSub
            :obj-data="sau"
            tipus="subtheme"
            :tree="selectedTheme + ','"
            :internal-checks="internalChecks"
            :open-option="sau.label === selectedSubtheme"
            @op-selected="thesaurusOpSelected"
            @change-internal-checks="changeInternalChecks"
          />
        </div>
      </div>
    </div>
    <div class="grid-options">
      <div v-if="selectedTheme && selectedSubtheme">
        <div v-for="sau in currentDetails.subThemes" :key="sau.label" class="checkbox-pill">
          <CheckboxSub
            :obj-data="sau"
            tipus="detail"
            :tree="selectedTheme + ',' + selectedSubtheme + ','"
            :internal-checks="internalChecks"
            :open-option="false"
            @op-selected="thesaurusOpSelected"
            @change-internal-checks="changeInternalChecks"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="thesaurus && isMobile" class="grid-wrap">
    <CheckboxSub
      :obj-data="{label: $t('all_op') }" 
      tipus="theme"
      :internal-checks="internalChecks"
      :open-option="false"
      @op-selected="thesaurusOpSelected"
      @change-internal-checks="changeInternalChecks"
    />
    <div
      v-for="sau in thesaurus.theme"
      :key="sau.label"
      class="checkbox-pill"
      :class="sau.label === selectedTheme && 'selected-op'"
    >
      <CheckboxSub
        :obj-data="sau"
        tipus="theme"
        :internal-checks="internalChecks"
        :open-option="sau.label === selectedTheme"
        @op-selected="thesaurusOpSelected"
        @change-internal-checks="changeInternalChecks"
      />
      <div v-if="selectedTheme && selectedTheme === sau.label">
        <div
          v-for="saur in currentSubthemes.subThemes"
          :key="saur.label"
          class="checkbox-pill"
          :class="saur.label === selectedSubtheme && 'selected-op'"
        >
          <CheckboxSub
            :obj-data="saur"
            tipus="subtheme"
            :tree="selectedTheme + ','"
            :internal-checks="internalChecks"
            :open-option="saur.label === selectedSubtheme"
            @op-selected="thesaurusOpSelected"
            @change-internal-checks="changeInternalChecks"
          />
          <div v-if="selectedTheme && selectedSubtheme && selectedSubtheme === saur.label">
            <div v-for="tsau in currentDetails.subThemes" :key="tsau.label" class="checkbox-pill">
              <CheckboxSub
                :obj-data="tsau"
                tipus="detail"
                :tree="selectedTheme + ',' + selectedSubtheme + ','"
                :internal-checks="internalChecks"
                :open-option="false"
                @op-selected="thesaurusOpSelected"
                @change-internal-checks="changeInternalChecks"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxSub from './CheckboxSub'
export default {
  name: 'ThemesGrid',
  components: { CheckboxSub },
  props: {
    thesaurus: {
      type: Object,
    },
    internalChecks: {
      type: Array,
    },
  },
  data() {
    return {
      selectedTheme: null,
      selectedSubtheme: null,
    }
  },
  computed: {
    currentSubthemes() {
      if (this.selectedTheme) {
        return this.thesaurus.theme.find(el => el.label === this.selectedTheme)
      } else return null
    },
    currentDetails() {
      if (this.selectedTheme && this.selectedSubtheme) {
        let subT = this.thesaurus.theme.find(el => el.label === this.selectedTheme)
        return subT.subThemes.find(elem => elem.label === this.selectedSubtheme)
      } else return null
    },
  },
  watch: {},
  methods: {
    thesaurusOpSelected(value, type) {
      if (type === 'theme' && value !== this.selectedTheme) {
        this.selectedTheme = value
        this.selectedSubtheme = null
      }
      else if (type === 'subtheme' && value !== this.selectedSubtheme) this.selectedSubtheme = value
    },
    changeInternalChecks(val) {
      this.$emit('change-internal-checks', val)
    },
  },
}
</script>

<style lang="stylus" scoped>
.grid-wrap
  display: flex
  justify-content: space-between
  width: 100%
  
  .mobile &
    flex-direction: column

  .grid-options
    width: 32.5%

    &:not(:last-child)
      margin-right: 0.75%
      padding-right: 0.75%
      border-right: 1px solid $light-grey

    .checkbox-pill
      border-radius: 4px

      &.selected-op
        background-color: $light-grey
</style>